import Icon from 'icons/Icon';

export const AccordionIndicator = ({ expanded, hasError = false }: { expanded: boolean; hasError?: boolean }): JSX.Element => (
  <div className={'w-[14px] h-[14px] flex items-center justify-center'}>
    <span
      className={`inline-flex h-1.5 w-1.5 transform border-b border-r border-[#667085] transition-transform duration-200 ${expanded ? 'rotate-45' : '-rotate-45'} ${hasError ? 'text-f-red-1' : ''} }`}
    />
  </div>
);

export const AccordionOpenCloseIcon = ({ expanded, hasError = false }: { expanded: boolean; hasError: boolean }): JSX.Element => (
  <div className='w-[14px] h-[14px] flex items-center justify-center'>
    <Icon icon={expanded ? 'open-accordion' : 'close-accordion'} className={`text-[#667085] ${hasError ? 'text-f-red-1' : ''}`} />
  </div>
);
